import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';

const getErrorDetails = (error: unknown): { title: string; message: string } => {
  if (isRouteErrorResponse(error)) {
    return {
      title: `${error.status} ${error.statusText}`,
      message: error.data?.message ?? 'This page could not be loaded.'
    };
  }
  if (error instanceof Error) {
    return { title: 'Something went wrong', message: error.message };
  }
  return { title: 'Unexpected error', message: 'An unknown error occurred.' };
};

export const ErrorPage = () => {
  const error = useRouteError();
  const { title, message } = getErrorDetails(error);

  return (
    <div className="site-shell">
      <div className="container" style={{ paddingTop: '6rem', paddingBottom: '4rem' }}>
        <div style={{
          maxWidth: '560px',
          margin: '0 auto',
          background: 'linear-gradient(180deg, rgba(18, 23, 42, 0.96), rgba(11, 16, 32, 0.96))',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius)',
          boxShadow: 'var(--shadow)',
          padding: '3rem',
          textAlign: 'center'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⚠</div>
          <h1 style={{ fontSize: '1.5rem', margin: '0 0 0.75rem', lineHeight: 1.2 }}>{title}</h1>
          <p style={{ color: 'var(--text-soft)', marginBottom: '2rem', lineHeight: 1.6 }}>{message}</p>
          <Link to="/" className="button button--primary" style={{ textDecoration: 'none' }}>
            Go to home
          </Link>
          {import.meta.env.DEV && error instanceof Error && error.stack && (
            <details style={{ marginTop: '2rem', textAlign: 'left' }}>
              <summary style={{ cursor: 'pointer', color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '0.5rem' }}>
                Stack trace
              </summary>
              <pre style={{
                fontSize: '0.75rem',
                color: 'var(--text-muted)',
                background: 'rgba(0,0,0,0.3)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-sm)',
                padding: '1rem',
                overflowX: 'auto',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }}>
                {error.stack}
              </pre>
            </details>
          )}
        </div>
      </div>
    </div>
  );
};
